/* eslint-disable no-unused-vars */
import request from '../../request'
import jsFileDownload from 'js-file-download'
import { transitionDownUrlObj } from '@/services/utils/modules/base'

export default {
  fetchOssTempAccessToken: (data, options = {}) => {
    return request(
      {
        url: '/uploaded/credit',
        method: 'get',
        desc: '获取oss零时token'
      },
      data,
      options
    )
  },
  /**
   * 根据业务场景导入数据，数据需要先上传到oss, 这里仅仅提供一个文件名称
   * @param {*} data { template, filePath, platformId, shareType  }
   * @param {*} options
   * @returns
   */
  fetchImportFile: (data, options = {}) => {
    return request(
      {
        url: '/uploaded/import',
        method: 'post',
        desc: '根据业务场景导入数据'
      },
      data,
      options
    )
  },
  /**
   * 根据业务场景下载模板
   * @param {*} template
   * @param {*} filename
   * @param {*} data 额外信息
   * @param {*} options options
   * @returns
   */
  async fetchDownloadTpl(template, filename = '文件', data = {}, options = {}) {
    const res = await request(
      {
        url: '/uploaded/tpl',
        method: 'post',
        responseType: 'blob', // important, request对axios 二次封装，注意参数书写位置
        desc: '下载模板'
      },
      {
        template,
        ...data
      },
      options
    )

    jsFileDownload(res, filename)

    return true
  },
  /**
   * 导出错误列表文件
   * @param {*} eventId
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchDownloadErrorList(eventId, data = {}, options = {}) {
    const res = await request(
      {
        url: '/uploaded/import/error',
        method: 'post',
        responseType: 'blob', // important, request对axios 二次封装，注意参数书写位置
        desc: '下载模板'
      },
      {
        eventId,
        ...data
      },
      options
    )

    jsFileDownload(res, '错误列表.xlsx')

    return true
  },
  /**
   * 导出系统sku的数据，条件和查询列表相同
   * @param {*} data
   * @param {*} options
   * @returns
   */
  async fetchDownloadSystemSku(data = {}, options = {}) {
    const res = await request(
      {
        url: '/expense/export/system/sku',
        method: 'post',
        responseType: 'blob', // important, request对axios 二次封装，注意参数书写位置
        desc: '下载模板'
      },
      {
        ...data
      },
      options
    )

    jsFileDownload(res, '系统sku导出数据.xlsx')

    return true
  },
  /**
   * 获取到下载地址，根据oss fileName
   * @param {*} data {fileName: 'ossFileName'}
   * @param {*} options
   * @returns
   */
  fetchDownloadUrlByOssFileName: (data = {}, options = {}) => {
    return request(
      {
        url: '/uploaded/getFileUrl',
        method: 'get',
        desc: ''
      },
      data,
      options
    )
  }
}
